<script>
  import { pageToLoad, flowData, user } from "./scripts/stores.js";

  const loginClick = () => {
    $flowData.loginDestination = "dashboard";
    pageToLoad.set("login");
  };

  const workshopClick = () => {
    $flowData.loginDestination = "pay";
    pageToLoad.set("workshops");
  };

  const dashboardClick = () => {
    pageToLoad.set("dashboard");
  };
</script>

<main class="page">
  <div class="container">
    <h1>Synthase Scales Workshop</h1>
    <p>
      Hello! Please login or sign up. Be sure to use the email address we have
      been using to communicate. If you're under 13, have your parent sign up
      with the email address we've been using to communicate. Thanks!
    </p>
    <p>-Nate</p>
    {#if $user.loggedIn}
      <div class="button-primary" on:click={dashboardClick}>Dashboard</div>
    {:else}
      <div class="button-primary" on:click={loginClick}>Login or Sign Up</div>
    {/if}
    <!-- <div class="button-primary" on:click={workshopClick}>Find a Workshop</div> -->
  </div>
</main>

<style>
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }
</style>
